import errors from "./constants";

export default function validateContainerImage(value: string) {
  const pattern =
    /^([a-zA-Z0-9.-]+(:[0-9]+)?\/)?[a-z0-9]+([._-][a-z0-9]+)*(\/[a-z0-9]+([._-][a-z0-9]+)*)*(?:[:][a-zA-Z0-9._-]+)?(?:@sha256:[a-fA-F0-9]{64})?$/;
  return pattern.test(value) ? undefined : errors.invalidImage;
}
